import { ReportTypeItem } from './report-type-item';

export class ReportCategory {
    categoryName: string;
    reportTypes: ReportTypeItem[];
}
